export const HIDE_BOTTOM_NAV = "HIDE_BOTTOM_NAV";
export const hideBottomNav = () => ({ type: HIDE_BOTTOM_NAV });

export const SHOW_BOTTOM_NAV = "SHOW_BOTTOM_NAV";
export const showBottomNav = () => ({ type: SHOW_BOTTOM_NAV });

export const TOGGLE_BOTTOM_NAV = "TOGGLE_BOTTOM_NAV";
export const toggleBottomNav = () => ({ type: TOGGLE_BOTTOM_NAV });
